<template>
	
	<div id="posts-blog" class="pt-5 pb-5">

	  <v-container>

	    <h1 class="text-center">¡Enterate!</h1>

	    <p style="text-align: center;color: gray;font-weight: bold;text-transform: uppercase;">
	    	<small>¡Informate de las ultimas novedades que tenemos para ti! </small>
	    </p>

	    <v-row class="mt-10" id="posts-desktop">

	      <v-col lg="3" sm="6" cols="12" v-for="post in posts">

	        <v-card class="mx-auto pb-5">
	          <v-img
	            class="white--text align-end"
	            height="200px"
	            :src="backend+'../storage/app/'+post.img"
	          >
	        	</v-img>

	          <v-card-subtitle class="pb-0 text-center">
	            <h3>{{post.title}}</h3>
	          </v-card-subtitle>

	          <v-card-text class="text--primary mt-4">
	            <p class="mb-3 post-content">
	              <b>{{post.introduction}}</b>
	            </p>
	            <p class="text-right ma-0" style="color: gray;">
	            	<small><b><i>{{ dateFormat2(post.created_at) }}</i></b></small>
	            </p>
	          </v-card-text>

	          <div class="text-center" style="margin-top: -10px">
	            <v-btn color="secondary" tile :to="'/post/'+post.id">
	              Ver mas
	            </v-btn>
	          </div>
	            
	        </v-card>

	      </v-col>

	    </v-row>


	    <v-carousel
        cycle
        :show-arrows="false"
        class="mt-5"
        id="posts-resp"
      >
        <v-carousel-item
          v-for="post in posts"
        >
          
        	<v-card class="mx-auto pb-5">
        	  <v-img
        	    class="white--text align-end"
        	    height="200px"
        	    :src="backend+'../storage/app/'+post.img"
        	  >
        		</v-img>

        	  <v-card-subtitle class="pb-0 text-center">
        	    <h3>{{post.title}}</h3>
        	  </v-card-subtitle>

        	  <v-card-text class="text--primary mt-4">
        	    <p class="mb-3 post-content">
        	      <b>{{post.introduction}}</b>
        	    </p>
        	    <p class="text-right ma-0" style="color: gray;">
        	    	<small><b><i>{{ dateFormat(post.created_at) }}</i></b></small>
        	    </p>
        	  </v-card-text>

        	  <div class="text-center" style="margin-top: -10px">
        	    <v-btn color="secondary" tile :to="'/post/'+post.id">
        	      Ver mas
        	    </v-btn>
        	  </div>
        	    
        	</v-card>

        </v-carousel-item>
      </v-carousel>


	    <div class="text-center mt-12 mb-5">
	    	<v-btn rounded x-large dark to="/blog/">Mostrar todos</v-btn>
	    </div>


	  </v-container>

	</div>

</template>



<style scoped>
	
	#posts-blog {
		background: #f4f4f4;
	}

	#posts-resp {
		display: none;
	}

	.post-content {
		text-align: justify;
		color: gray;
		height: 90px;
		overflow: hidden;
	}

	@media(max-width: 959px) {

		#posts-blog {
			padding-left: 30px;
			padding-right: 30px;
		}

	}

	@media(max-width: 425px) {

		#posts-blog {
			padding-left: 20px;
			padding-right: 20px;
		}

		#posts-blog h1 {
			font-size: 2.5rem !important;
		}

		#posts-desktop {
			display: none;
		}

		#posts-resp {
			display: block;
		}

	}

</style>



<script>
	
	import BlogService from '@/shared/services/BlogService'

	export default
	{
		data() {
			return {
				posts: []
			}
		},

		created() {
			this.getPosts()
		},

		methods: {

			async getPosts()
			{
				const resp = await BlogService.getPresentation()

				console.log(resp.data)

				this.posts = resp.data
			},


			dateFormat2(date)
			{
			  let d = new Date(date)
			  let months = Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');


			  let month = months[d.getMonth()]
			  let day = d.getDate().toString().padStart(2,'0')
			  let year = d.getFullYear()


			  return day + ' de ' + month + ' del ' + year
			}

		}

	}

</script>